import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c349822a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"margin-bottom":"34px"},
  class: "position_box"
}
const _hoisted_2 = {
  key: 0,
  class: "hint_box",
  style: {'color':'#e02020'}
}
const _hoisted_3 = { class: "register_btn" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Create Account")
const _hoisted_5 = { class: "register_type" }
const _hoisted_6 = { class: "position_bottom" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Or Connect With")
const _hoisted_8 = { class: "facebook_box" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Have an account？")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("By clicking this button, I agree with the ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loginVue = _resolveComponent("loginVue")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_phoneEmailVue = _resolveComponent("phoneEmailVue")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_tabs, {
      active: $setup.tabActive,
      "onUpdate:active": _cache[10] || (_cache[10] = ($event: any) => (($setup.tabActive) = $event)),
      "title-active-color": "#333",
      "title-inactive-color": "#ccc",
      "line-width": "60px",
      "line-height": "4px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "LOGIN" }, {
          default: _withCtx(() => [
            _createVNode(_component_loginVue, {
              onGoRegisterFn: $setup.goRegisterFn,
              Toast: $setup.Toast
            }, null, 8, ["onGoRegisterFn", "Toast"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "REGISTER" }, {
          default: _withCtx(() => [
            _createVNode(_component_phoneEmailVue, {
              class: "register_box",
              isEmail: $setup.registerType,
              ref: "fromDate",
              Toast: $setup.Toast
            }, {
              center: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_van_field, {
                    modelValue: $setup.password,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => (($setup.password) = $event)),
                      _cache[3] || (_cache[3] = ($event: any) => ($setup.watchPaswFn()))
                    ],
                    modelModifiers: { trim: true },
                    class: "inputBox",
                    type: $setup.isShowPassword?'text':'password',
                    "right-icon": $setup.isShowPassword?'eye':'closed-eye',
                    center: "",
                    clearable: "",
                    onClear: _cache[1] || (_cache[1] = ($event: any) => ($setup.passwordVerify = true)),
                    onClickRightIcon: $setup.isShowPWFn,
                    "left-icon": 'https://image.kilimall.com/kenya/wap/icons/password.png'.webpFilters()
,
                    placeholder: "Enter Password",
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.verifyLength()))
                  }, null, 8, ["modelValue", "type", "right-icon", "onClickRightIcon", "left-icon"]),
                  (!$setup.passwordVerify)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Minimum 6 characters required."))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["isEmail", "Toast"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_van_button, {
                class: "register_btn",
                color: "#F76900",
                round: "",
                type: "primary",
                onClick: $setup.submitFn,
                disabled: $setup.loading,
                loading: $setup.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick", "disabled", "loading"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.registerTypeFn && $setup.registerTypeFn(...args)))
              }, _toDisplayString($setup.registerType?'Register via Phone number':'Register via Email'), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_van_divider, { class: "or_box" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                (!$setup.isByteApp)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: 'https://image.kilimall.com/kenya/new_wap/share/facebook_icon.png'.webpFilters()
,
                      alt: "",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.facebookLogin && $setup.facebookLogin(...args)))
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                (!$setup.isByteApp)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: 'https://image.kilimall.com/kenya/new_wap/share/google.png'.webpFilters()
,
                      alt: "",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.googleLogin && $setup.googleLogin(...args)))
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _hoisted_11,
                  _createElementVNode("span", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.tabActive = 0))
                  }, "Login")
                ]),
                _createVNode(_component_van_checkbox, {
                  modelValue: $setup.PrivacyChecked,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.PrivacyChecked) = $event)),
                  "checked-color": "#F87622",
                  "icon-size": "18px"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createElementVNode("span", {
                      class: "span_link",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => ($setup.goPriFn && $setup.goPriFn(...args)), ["stop"]))
                    }, "Terms and Conditions and Privacy Policies.")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(_component_van_icon, {
      name: "arrow-left",
      size: "34",
      class: "arrow_btn",
      onClick: $setup.goHomeFn
    }, null, 8, ["onClick"])
  ], 64))
}